// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1x6kH","toggle":"styles_toggle__2ox-u","preview":"styles_preview__2cJbP"};